import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberfr',
})
export class NumberPipe implements PipeTransform {
  transform(value:number):string {
     let result = '';
     if (value !== null && value !== undefined && !Number.isNaN(value)) {
        if (typeof(value) === 'string') {
           value = Number.parseFloat(value);
        }
        const parts = value.toString().split(',');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' '); // NOSONAR
        result=parts.join(',') + '';
     } else {
        result='0,00';
     }
     return result;
  }
}